import { safeGetError } from './safeGetError';
import { AppConfig } from '@/classes/AppConfig';
import { RetryPromiseWithBackoffAndFallbackLogging } from '@/classes/DurableVideo/RetryPromiseWithBackoffAndFallbackLogging';
import { HttpStatus } from '@/constants';
import Logger from '@/classes/Logger';
import EnvironmentHelper from '@/classes/EnvironmentHelper/EnvironmentHelper';

const logErrorToSentry = (error: unknown) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (typeof Sentry === 'undefined') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  Sentry?.captureException(error);
};

export const logErrorExternally = (
  message: string,
  error: unknown,
  className = '',
  details: Record<string, unknown> = {},
  logChainId = '',
) => {
  const extendedMessage = `${className}: ${message}`;
  const errorDetails = safeGetError(error);
  const extendedDetails = {
    ...details,
    className,
    error,
    message: errorDetails?.error || 'unknown',
    stack: errorDetails?.stack || 'unknown',
  };

  console.error(extendedMessage, extendedDetails);

  logErrorToSentry(error);

  // If we can't log the request externally, log the error to the console
  const retryWithBackoff = new RetryPromiseWithBackoffAndFallbackLogging([HttpStatus.BAD_REQUEST]);
  retryWithBackoff
    .run(async () => {
      const logger = new Logger({
        appName: AppConfig.xsrc,
        xsrc: AppConfig.xsrc,
        env: EnvironmentHelper.getEnvironment(),
      });
      logger.error(extendedMessage, extendedDetails);
      console.error(extendedMessage, extendedDetails);
    })
    .catch((loggingError) => {
      console.error(
        'Error logging error',
        loggingError,
        'Original error:',
        message,
        error,
        details,
        className,
        logChainId,
      );
    });
};
